export const MAIN_BLUE = "#004198";
export const MAIN_WHITE = "#FFFFFF";

export const COMP_GREEN: string = "#02a16c";
export const COMP_YELLOW: string = "#FFCC01";
export const COMP_RED: string = "#FF4F4D";
export const COMP_NEUTRAL: string = "#e0e0e0";
export const COMP_GRAY = "#515151";
